import "./About.scss";
import aboutImg from "../../Assets/Lagoon park Bukit Golf Riverside.webp";
import { ReactComponent as Checkin } from "../../Assets/svg/checkin.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import aboutImages from "../../Assets/Facilities/aboutImages";

const About = () => {
  const pointData = [
    "Dikembangkan oleh Developer yang Terpercaya",
    "Desain Perumahan Unik dan Modern",
    "Harga Terjangkau dengan Banyak Tipe Pilihan",
    "Lingkungan Asri dengan Danau Alami yang Luas",
    "Lokasi Strategis, 1 Km Saja dari Pintu Tol",
    "Berada di dalam Kawasan Golf",
  ];
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281220003574&text=Halo+Lenny,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20The%20Lagoon%20Park%20Bukit%20Golf%20Riverside?%20http://marketingbukitgolfriverside.com/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyload: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };
  return (
    <section className="section-about" id="about">
      <div className="container-about">
        <div className="text">
          <div className="label">Bukit Golf Riverside</div>
          <h4 className="title">Lingkungan Asri dengan View Danau Alami</h4>
          <p className="desc">
            Sehat Bersama Alam di Lagoon Park. Hirup udara segar perbukitan yang
            kaya akan oksigen, nikmati keindahan alam yang menenangkan, dan
            rasakan peningkatan kualitas hidup Anda. The Lagoon Park Bukit Golf
            Riverside adalah investasi terbaik untuk kesehatan Anda dan
            keluarga.
          </p>
          {pointData.map((point) => (
            <div className="points">
              <Checkin
                width={21}
                height={21}
                fill={"#1F4166"}
                className="icon"
              ></Checkin>
              <span>{point}</span>
            </div>
          ))}
          <button onClick={waOpen} className="btn-navbar">
            Learn More
          </button>
        </div>
        <div className="image">
          <img src={aboutImg} alt="about The Lagoon Park" />
        </div>
      </div>
      <div className="slider">
        <Slider {...settings}>
          {aboutImages.map((image) => (
            <div className="slide">
              <img src={image} alt="about The Lagoon Park" />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default About;
